import { useCallback, useState } from "react";
import { HostRoute } from "./types";
import { InputOnChangeData } from "semantic-ui-react";

const useHostRoutesChange = (
  hostRoutes: HostRoute[],
  onHostRoutesChange: (data: HostRoute[]) => void,
) => {
  const [isErrorShowing, setIsErrorShowing] = useState(false);

  const onDestinationChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>, data: InputOnChangeData) => {
      const { "data-index": index, value } = data;
      const newHostRoutes = hostRoutes.map((item, i) =>
        i === index ? { ...item, destination: value } : item,
      );
      onHostRoutesChange(newHostRoutes);
      setIsErrorShowing(false);
    },
    [hostRoutes, onHostRoutesChange],
  );

  const onNextHopChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const index = Number(event.target.dataset.index);
      const value = event.target.value;
      const newHostRoutes = hostRoutes.map((item, i) =>
        i === index ? { ...item, nexthop: value } : item,
      );
      onHostRoutesChange(newHostRoutes);
      setIsErrorShowing(false);
    },
    [hostRoutes, onHostRoutesChange],
  );

  const onAddRow = useCallback(() => {
    const newHostRoutes = [...hostRoutes, { destination: "", nexthop: "" }];
    onHostRoutesChange(newHostRoutes);
    setIsErrorShowing(false);
  }, [hostRoutes, onHostRoutesChange]);

  const onDeleteRow = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const index = Number(event.currentTarget.dataset.index);
      const newHostRoutes = hostRoutes.filter((_, i) => i !== index);
      onHostRoutesChange(newHostRoutes);
      setIsErrorShowing(false);
    },
    [hostRoutes, onHostRoutesChange],
  );

  return {
    onDestinationChange,
    onNextHopChange,
    onAddRow,
    onDeleteRow,
    isErrorShowing,
    setIsErrorShowing,
  };
};
export default useHostRoutesChange;
